import firebase from 'firebase/app';
import 'firebase/messaging';
import 'firebase/database';
import { invokeOnce } from '../../util/functions';

const firebaseConfig = {
    apiKey: "AIzaSyCAbTYS7f5x4eEZ6Bzcn8ZCjoGrMvlCWRE",
    authDomain: "cellrepairment.firebaseapp.com",
    databaseURL: "https://cellrepairment.firebaseio.com",
    projectId: "cellrepairment",
    storageBucket: "cellrepairment.appspot.com",
    messagingSenderId: "522098890219",
    appId: "1:522098890219:web:9c24043110bacd20"
};

const techLocTrackingPath = 'tech_loc_tracking';
const installServiceWorkerSingle = invokeOnce(installServiceWorker);

export function initializeFirebaseApp() {
    if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
    }
}

const globalFirebaseData = {
    deviceToken: null,
    serviceWorkerRegistered: false
};

export async function getMessagingToken() {
    return await firebase.messaging().getToken()
}

export function getGlobalFirebaseData() {
    return globalFirebaseData;
}

function refreshToken() {
    firebase.messaging().getToken();
}

export async function initializeFirebaseMessaging({ dispatch, notificationReceivedActionBuilder: notificationReceivedActionBuilder }) {
    const messaging = firebase.messaging();
    try {
        await messaging.requestPermission();
        await installServiceWorkerSingle();
        const token = await messaging.getToken();
        console.log(token);
        globalFirebaseData.deviceToken = token;
    } catch (error) {
        if (error.code === "messaging/permission-blocked") {
            alert("Please unlock notification request in your browser settings.");
        } else {
            console.error("Error Occurred", error);
        }
    }

    messaging.onTokenRefresh(() => refreshToken());

    const handleNotification = notification => {
        // console.log('Message received. ', notif);
        const { data: { title, body, type } } = notification;
        if (title) {
            dispatch(notificationReceivedActionBuilder({ title, body, type }));
        }
    };

    messaging.onMessage(notification => {
        handleNotification(notification)
    });

    window.receiveFakeNotification = notification => {
        handleNotification(notification)
    };
}

async function installServiceWorker() {
    if ('serviceWorker' in navigator) {
        try {
            const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
            firebase.messaging().useServiceWorker(registration);
        } catch (err) {
            console.log('Service worker registration failed, error:', err);
        }
    }
}

const listenDatabaseValue = (dbRootRef, childRef, cb) => {
    try {
        const ref = dbRootRef.ref(childRef);
        const valueListener = ref.on('value', data => cb(data.val()));
        return () => ref.off('value', valueListener);
    } catch (e) {
        console.log(e);
        //ignore
    }
};

export function getLocalizationService() {
    const dbRootRef = firebase.database();
    return {
        listenTechLocationValue: (techId, cb = () => 0) => {
            return listenDatabaseValue(dbRootRef, `${techLocTrackingPath}/${techId}`, cb);
        },
    }
}
